module.exports = __webpack_public_path__ + "9ea02fac26ca02d02782919dd6101bb0.png";